import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from 'treeline-react-core-components/UserAvatar';
import { connectToUser } from './containers/UserDataStore';
import { Translate } from '@above-the-treeline/localization';
import { Link } from 'react-router-dom';
import paths from '../../paths';
import './userOverview.less';

UserOverview.propTypes = {
	userDataStore: PropTypes.object,
	closePopover: PropTypes.func,
};

function UserOverview({ userDataStore, closePopover }) {
	const renderCommunicationSettingsLink = () => (
		<Link
			className="clickable"
			to={paths.communicationSettings()}
			onClick={closePopover}>
			<span className="acc-font bold">
				<Translate id="communication_settings" />
			</span>
		</Link>
	);

	const renderProfileEditorLink = () => (
		<Link
			className="clickable"
			to={paths.profileEditor()}
			onClick={closePopover}>
			<span className="acc-font bold">
				<Translate id="view_edit_your_profile" />
			</span>
		</Link>
	);

	const signOut = () => {
		const logoutUrl = userDataStore.getLogoutUrl();

		fetch(logoutUrl, {
			method: 'POST',
			credentials: 'include',
		}).then(() => {
			window.location.reload();
		});
	};

	const { isLoading, user } = userDataStore.state;

	return (
		<div className="user-overview">
			{!isLoading && (
				<div
					className="pad-top-10"
					style={{ width: '300px', height: '165px' }}>
					<div style={{ marginTop: '-5px' }}>
						<div
							className="column-right acc-font"
							style={{ fontSize: '13px' }}
							onClick={signOut}>
							Sign Out
						</div>
						<div className="clear" />
					</div>
					<div style={{ paddingTop: '5px' }}>
						<div className="column">
							{user.userAvatar && (
								<UserAvatar
									userInitials={user.userAvatar.initials}
									avatarUri={
										(user.userAvatar.uri &&
											user.userAvatar.uri.replace(
												'height=100',
												'height=300',
											)) ||
										null
									}
									displayName={user.userAvatar.displayName}
									avatarSizeClass={UserAvatar.large}
								/>
							)}
						</div>
						<div
							className="column-spaced"
							style={{ width: '180px' }}>
							<div
								className="dotDot"
								style={{
									fontSize: '18px',
									fontWeight: 'bold',
									width: '150px',
								}}>
								{user.userAvatar.displayName}
							</div>
							{user.userAvatar.displayName !==
							user.organization.name ? (
								<div
									className="bold dotDot"
									title={user.organization.name}>
									{user.organization.name}
								</div>
							) : (
								<React.Fragment />
							)}
							{user.organization &&
							user.organization.address &&
							user.organization.address.city &&
							user.organization.address.stateProvince ? (
								<div className="dotDot">
									{user.organization.address.city}{' '}
									{user.organization.address.stateProvince}
								</div>
							) : (
								<React.Fragment />
							)}
							<div className="dotDot">
								{user.user.classification}
							</div>
							<div className="navigation-link dotDot acc-font bold">
								{renderProfileEditorLink()}
							</div>
							<div className="navigation-link dotDot acc-font bold">
								{renderCommunicationSettingsLink()}
							</div>
						</div>
						<div className="clear" />
					</div>
				</div>
			)}
		</div>
	);
}

export default connectToUser(UserOverview);
